import { NOTIFICATION_COUNT } from '../../constants';

const initialState = {
  data: {},
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case NOTIFICATION_COUNT.LOAD:
      return {
        ...state,
        loading: true,
      };
    case NOTIFICATION_COUNT.SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload,
      };
    case NOTIFICATION_COUNT.FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
}
